import { ApolloError } from "@apollo/client"

export const getGraphqlErrorMessage = (error: ApolloError): string => {
  // First try GraphQL errors
  if (error.graphQLErrors.length > 0) {
    return error.graphQLErrors.map((ge) => ge.message).join(", ")
  }

  // @ts-expect-error bad types?
  if (error.networkError?.result?.errors?.length > 0) {
    // @ts-expect-error bad types?
    return error.networkError.result.errors.map((e: any) => e.message).join(", ")
  }

  // Fall back to general error message
  return error.message
}

export const GraphqlError = ({
  error,
  variant = "unexpected",
}: {
  error: ApolloError
  variant?: "unexpected" | "red-box"
}) => {
  switch (variant) {
    case "unexpected":
      return (
        <ErrorBox>
          <div className="mb-2 font-semibold">An error occured</div>
          <div className="mb-2 text-sm">{getGraphqlErrorMessage(error)}</div>
          <details>
            <summary className="cursor-pointer text-xs text-red-500 hover:text-red-400">
              Show full error details
            </summary>
            <div className="mt-2">
              {error.graphQLErrors.map((e, i) => (
                <pre key={i} className="text-xs">
                  {JSON.stringify(e, null, 2)}
                </pre>
              ))}
              {error.graphQLErrors.length === 0 ? (
                <pre className="text-xs">{JSON.stringify(error, null, 2)}</pre>
              ) : null}
            </div>
          </details>
        </ErrorBox>
      )
    case "red-box":
      return (
        <div className="rounded-md bg-destructive p-4 text-destructive-foreground">
          {getGraphqlErrorMessage(error)}
        </div>
      )
    default:
      throw variant satisfies never
  }
}

export const ErrorBox = ({ children }: { children: React.ReactNode }) => (
  <div className="flex-shrink-0 overflow-auto">
    <div className="flex-shrink-0 overflow-auto rounded border border-red-500 p-3 text-red-600">
      {children}
    </div>
  </div>
)
